"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmChainParser = void 0;
var core_1 = require("@moralisweb3/core");
var EvmChainParser = /** @class */ (function () {
    function EvmChainParser() {
    }
    EvmChainParser.parse = function (chain) {
        if (typeof chain === 'string') {
            if (chain.startsWith('0x') && chain !== '0x' && chain !== '0x0') {
                return chain;
            }
            throw new core_1.MoralisCoreError({
                code: core_1.CoreErrorCode.INVALID_ARGUMENT,
                message: "Invalid provided chain, value must be a positive number, or a hex-string starting with '0x'",
            });
        }
        if (chain <= 0) {
            throw new core_1.MoralisCoreError({
                code: core_1.CoreErrorCode.INVALID_ARGUMENT,
                message: "Invalid provided chain, value must be a positive number, chain-name or a hex-string starting with '0x'",
            });
        }
        return "0x".concat(chain.toString(16));
    };
    return EvmChainParser;
}());
exports.EvmChainParser = EvmChainParser;
//# sourceMappingURL=EvmChainParser.js.map